const colors = {
  orange: {
    fg: 'rgb(240,173,78)',
    bg: 'rgb(212,153,70)',
  },
  green: {
    fg: 'rgb(92,184,92)',
    bg: 'rgb(82,160,82)',
  },
  blue: {
    fg: 'rgb(91,192,222)',
    bg: 'rgb(82,169,195)',
  },
  grey: {
    fg: 'rgb(33,33,33)',
    bg: 'rgb(100,100,100)',
  },
};

angular.module('app.directives')
.directive('dashStatus', ($filter) =>
({
    restrict: 'E',
    scope: {
        dashStatus: '@',
        diagnosticStatus: '@',
        broadcast: '=',
        bottomRow: '=bottomRow'
    },
    link(scope, element, attrs) {
        // Split the status string into two separate strings
        let str = $filter('underscoreToSpace')(scope.dashStatus);

        // Statuses come back with info split by ":" from the API.
        // We make the assumption that any number is indicative of 
        // a status.  The first portion of the split populates our
        // label, the second (if not a number), gets added to a tooltip.
        // Any piece that a number is used to fill out the label's background
        // as if it were a mini progress bar.  We also append the number to
        // tooltip values as a percentage.
        let statusArray = str.split(':');
        
        // Label is the first chunk
        scope.statusLabel = statusArray[0];
        if (scope.broadcast.stream_source == 'imported') {
          scope.statusLabel = 'Uploaded';
        }

        // Evaluate remaining chunks
        statusArray.splice(0,1);
        let percent = null;
        let moreInfo = null;
        for(let i=0; i < statusArray.length; i++) {
            if (parseInt(statusArray[i].match(/\d+/g))) {
                percent = statusArray[i] + "%";
            } else {
                moreInfo = statusArray[i];
            }
        }

        // Consider states where we want to avoid unnecessary stream health labelling
        scope.hideDiagnostics = false;
        if (scope.dashStatus == 'upcoming' || scope.dashStatus.indexOf('preparing') >= 0 || scope.broadcast.stream_source == 'imported') {
            scope.hideDiagnostics = true;
        }

        if (moreInfo && percent) {
            scope.moreInfo = moreInfo + " at " + percent;
        } else if (percent) {
            scope.moreInfo = percent;
        } else {
            scope.moreInfo = moreInfo;
        }

        // Override status color and show tooltip if stream diagnostics says a "LIVE" broadcast is struggling.
        let alerts = _.filter(((scope.broadcast||{}).stream_diagnostics||{}).alerts || [], (a) => a.is_active);
        let hasDiagnosticsAlerts = alerts.length > 0;
        if (scope.dashStatus == 'live' && hasDiagnosticsAlerts) {
            let alertMessages = _.map(alerts, 'message');
            scope.moreInfo = alertMessages.join(',');
        }

        scope.textClassForDiagnosticStatus = (diagnosticStatus) => {
            switch((diagnosticStatus||'').toLowerCase()) {
                case "ok":
                    return 'text-success';
                case "warning":
                    return 'text-warning-alt';
                case "critical":
                    return 'text-danger';
            }
            return 'text-muted';
        }

        scope.labelStyle = (status) => {
            if (!percent) return;

            // Mirror the colors used for our '.label' status classes
            // e.g. [ "fillColor" |  "backColor" ]
            let fillColor = colors.blue.fg;
            let backColor = colors.blue.bg;
            if (status === 'live') {
                if (hasDiagnosticsAlerts) {
                    fillColor = colors.orange.fg;
                    backColor = colors.orange.bg;
                } else {
                    fillColor = colors.green.fg;
                    backColor = colors.green.bg;
                }
            }
            if (status == 'recorded') {
                fillColor = colors.grey.fg;
                backColor = colors.grey.bg;
            }
            if (/(stalled|catching_up|missed)/i.test(status)) {
                fillColor = colors.orange.fg;
                backColor = colors.orange.bg;
            }
            return `background-image: linear-gradient(to right, ${fillColor} 0%, ${fillColor} ${percent}, ${backColor} ${percent}, ${backColor} 100%);`
        }
        
        scope.labelClassForStatus = (status) => {
            if (status === 'live') {
                if (hasDiagnosticsAlerts) {
                    return 'label-warning';
                } else {
                    return 'label-success';
                }
            }
            if (status === 'recorded') {
                return 'label-default';
            }
            if (/(stalled|catching_up|missed)/i.test(status)) {
                return 'label-warning';
            }
            return 'label-info';
        };

    },
    template: 
    `<div>
        <span class="label" ng-class="::labelClassForStatus(dashStatus)" ng-model="statusLabel" style="{{ ::labelStyle(dashStatus) }}" tooltip="{{ ::moreInfo }}" tooltip-enable="::!bottomRow && moreInfo">
            {{ ::statusLabel }}
        </span>
    </div>
    <div ng-if="::bottomRow" class="bottom-row clearfix" style="margin-left:0;white-space:nowrap;text-overflow:ellipsis;text-transform:capitalize;">
        <span ng-if="!hideDiagnostics" class="{{textClassForDiagnosticStatus(diagnosticStatus)}}" style="display:inline-block;max-width:50%;padding-right:5px;overflow:hidden;">
          <i class="fa fa-circle"></i>
          {{diagnosticStatus || 'Unknown'}}
        </span>
        <span style="display:inline-block;max-width:50%;overflow:hidden;">
          {{ ::moreInfo }}
        </span>
    </div>`,
}))
.directive('registerWaypoint', () =>
({
    restrict: 'A',
    scope: {},
    template: ``,
    link(scope, element, attrs) {
        const $shortcut = angular.element(document.getElementById('shortcut-to-top'));
        let waypoint = new Waypoint({
            element: element[0],
            handler: function(direction) {
                // TODO: Add shortcut to scroll to top
            }
        });
    }
}));


// WEBPACK FOOTER //
// ./views/dashboard/dashboard_directives.js